import { makeStyles, createStyles } from "@mui/styles";
import customColors from "../../styles/coreStyles/ColorPalette";
import customFonts from "../../styles/coreStyles/Fonts";
// import customFonts from "../../styles/coreStyles/Fonts";

const LogoBarStyle = makeStyles(() =>
  createStyles({
    appBarContainer: {
      backgroundColor: customColors.white,
      position: "static",
      height: 60,
      width: "100%",
    },
    appBarFixedContainer: {
      backgroundColor: customColors.white,
      // position: "fixed",
      // top: 0,
      height: 60,
      width: "100%",
      // zIndex: 1,
    },
    appBar: {
      backgroundColor: customColors.white,
      position: "static",
      height: 60,
    },
    toolBar: {
      display: "flex",
    },
    dfdsLogo: {
      display: "flex",
      alignItems: "center",
      cursor: 'pointer'
    },
    railWayIcon: {
      color: customColors.groupBlue,
      width: "25px",
      height: "25px",
      cursor: 'pointer'
    },
    centerText: {
      fontSize: "1rem",
      color: customColors.groupBlue,
      fontFamily: customFonts.boldFont,
      lineHeight: "24px" /* 150% */,
      letterSpacing: "0.444px",
      fontWeight: 600,
      marginLeft: "15px",
      marginRight: "5px",
      cursor: 'pointer'
    },
    freightShippingIcon: {
      color: customColors.groupBlue,
      fontSize: "2rem",
      marginLeft: "2rem",
    },
    accountIcon: {
      display: "flex",
      color: customColors.groupBlue,
      fontSize: "2rem",
    },
  })
);

export default LogoBarStyle;
